import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGamepadControls: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"gamepad-controls, joystick"} maskId="square-filled-radius-0-stroke-1-IconGamepadControls"><path d="M16 2H8V6.95711L12 10.9571L16 6.95711V2Z" fill="currentColor"/><path d="M22 8H17.0429L13.0429 12L17.0429 16H22V8Z" fill="currentColor"/><path d="M16 22V17.0429L12 13.0429L8 17.0429V22H16Z" fill="currentColor"/><path d="M2 8V16H6.95711L10.9571 12L6.95711 8H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGamepadControls;
